export const usersReducer = (state = {loading: false, resultuser: null, users: [], user: null, useractivate: null, technicians: [], usersForSelect: [], breeders: [], total: 0} , action) => {
    switch (action.type) {
        case 'USER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                users: action.payload.users,
                technicians: action.payload.users.filter(user => user.rol === 'technical'),
                breeders: action.payload.users.filter(user => user.rol === 'breeder'),
                total: action.payload.total
            }
        case 'USER_GETALLFORSELECT_SUCCESS':
            return {
                ...state,
                usersForSelect: action.payload,
                technicians: action.payload.filter(user => user.rol === 'technical'),
                breeders: action.payload.filter(user => user.rol === 'breeder'),
            }
        case 'USER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                user: action.payload.user
            }
        case 'USER_RESET':
            return {
                ...state,
                user: null
            }
        case 'USER_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message,
                useractivate: action.payload.idUser,
                user: action.payload.user,
                users: [...state.users, action.payload.user],
            }
        case 'USER_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message
            }
        case 'USER_EDIT_SUCCESS':
            if(action.payload.user){
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload.message,
                    user: action.payload.user,
                    users: state.users.map(user => user._id === action.payload.user._id ? action.payload.user : user),
                    technicians: state.technicians.map(user => user._id === action.payload.user._id ? action.payload.user : user),
                    breeders: state.breeders.map(user => user._id === action.payload.user._id ? action.payload.user : user),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultuser: action.payload
                }
            }
        case 'USER_NOTHINGHERE':
            return {
                ...state,
                loading: false,
                resultuser: 'nothinghere'
            }
        case 'USER_RESET_RESULT':
            return {
                ...state,
                resultuser: null
            }
        case 'USER_ENABLEDISABLE_SUCCESS': {
            return {
                ...state,
                loading: false,
                resultuser: action.payload.message
            }
        }
        case 'USER_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'USER_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

